var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertCircleRed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM10 5.5C10.5523 5.5 11 5.94772 11 6.5V9.99994C11 10.5522 10.5523 10.9999 10 10.9999C9.44772 10.9999 9 10.5522 9 9.99994V6.5C9 5.94772 9.44772 5.5 10 5.5ZM10 12.25C10.6904 12.25 11.25 12.8096 11.25 13.5V13.51C11.25 14.2004 10.6904 14.76 10 14.76C9.30964 14.76 8.75 14.2004 8.75 13.51V13.5C8.75 12.8096 9.30964 12.25 10 12.25Z",
    fill: "#EF4343"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertCircleRed);
export default __webpack_public_path__ + "static/media/alert-circle-red.798c07ee0d438878592c12664a6992cd.svg";
export { ForwardRef as ReactComponent };